import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ManageProductReservationDetail } from '@components/templates/myAccount';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function ManageProductReservationDetailPage() {
    const { uuid } = useParams();
    const { t } = useTranslation();

    const translations = {
        title: t('manage-product-reservation-detail-component.metatags.title'),
        description: t('manage-product-reservation-detail-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.manageProductReservationDetail.replace(':uuid', `${uuid}`),
        index: false,
    });

    return <ManageProductReservationDetail />;
}
